import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function formatDateTime(date) {
  return dayjs(date).isValid()
    ? dayjs(date).format("DD MMM YYYY hh:mm A")
    : `${date}`;
}

export function formatDate(date) {
  return dayjs(date).isValid()
    ? dayjs(date).format("DD MMM YYYY")
    : `${date}`;
}

